import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Lock, User, Boxes } from "lucide-react";
import axios from "axios";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { Card, CardContent } from "../components/ui/card";

const API = process.env.REACT_APP_BACKEND_URL;

export default function InventoryLogin() {
  const navigate = useNavigate();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (event) => {
    event.preventDefault();
    setError("");
    setLoading(true);
    try {
      const { data } = await axios.post(
        `${API}/api/inventory/auth/admin-login`,
        { username, password },
      );
      localStorage.setItem("e93_inventory_admin_token", data.token);
      navigate("/inventory");
    } catch (err) {
      setError(err.response?.data?.detail || "Gabim në lidhje");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-slate-950 flex items-center justify-center px-4">
      <Card className="w-full max-w-md border-none shadow-2xl">
        <CardContent className="p-10">
          <div className="text-center mb-8">
            <img
              src="/e93-logo.jpg"
              alt="E93"
              className="inline-block w-20 h-20 rounded-full object-cover mb-4"
            />
            <h1 className="text-3xl font-serif font-bold">Inventari E93</h1>
            <p className="text-gray-500 mt-2">
              Hyrja e Administratorit të Inventarit
            </p>
          </div>
          <form onSubmit={submit} className="space-y-5">
            <div>
              <Label>Përdoruesi</Label>
              <div className="relative mt-2">
                <User className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-gray-400" />
                <Input
                  className="pl-10 rounded-none"
                  value={username}
                  onChange={(e) => setUsername(e.target.value)}
                  required
                />
              </div>
            </div>
            <div>
              <Label>Fjalëkalimi</Label>
              <div className="relative mt-2">
                <Lock className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-gray-400" />
                <Input
                  className="pl-10 rounded-none"
                  type="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  required
                />
              </div>
            </div>
            {error && (
              <p className="text-sm text-red-700 bg-red-50 border border-red-200 p-3">
                {error}
              </p>
            )}
            <Button
              disabled={loading}
              className="w-full rounded-none py-6 bg-emerald-700 hover:bg-emerald-800"
            >
              {loading ? "Duke hyrë..." : "Hyr në Inventar"}
            </Button>
          </form>
        </CardContent>
      </Card>
    </div>
  );
}
